import React, { useState, useEffect,useRef  } from 'react';
import { Info,X } from 'lucide-react';
import { useHistory } from "react-router-dom";
import Tooltip from './Tooltip';
import useFetch from '../../hooks/useFetch';
import apiHelper from '../../apiHelper';
import DiscardConfirmationModal from '../../components/DiscardConfirmationModal';
import AlertNotification from '../../components/AlertNotification';
export default function AddEntities() {

    const { data, loading, error, fetchData } = useFetch();
    const [validationError, setValidationError] = useState();
    const [successMessage, setSuccessMessage] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [entities , setEntities] = useState([]);
    const [alert, setAlert] = useState(null);
    const history = useHistory();
    const [activeTab, setActiveTab] = useState("Add Entitie");

    const [formData, setFormData] = useState({
        entity_name: '',
        entity_short_name: '',
        status: '1',
        uen: '',
        note: '',
        parent_id: '',    
    });

    const [errors, setFormErrors] = useState({
        entity_name: '',
        uen: ''   
    });
    const [discardModalOpen, setDiscardModalOpen] = useState(false);
    const discardRef = useRef(null);
        const handleDiscard = () => {
        setDiscardModalOpen(true);
    };
    const handleDiscardConfirm = (confirm) => {
        if (confirm) {
            history.goBack();
        }
        setDiscardModalOpen(false);
    };
    const handleCancelDiscard = () => {
        setDiscardModalOpen(false);
    };

        useEffect(() => {
            function handleClickOutside(event) {
                if (discardRef.current && !discardRef.current.contains(event.target)) {
                    setDiscardModalOpen(false);
                }
            }
            if (discardModalOpen) {
                document.addEventListener("mousedown", handleClickOutside);
            }
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [discardModalOpen]);
    useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiHelper('entities/list/');
        if(response && response.ok){
          const result = await response.json();
          setEntities(result);
        }
      } catch (error) {
        console.error('Failed to fetch entities:', error);
      }
    }

    fetchData();
  }, []); // Empty dependency array ensures the effect runs only once

const [errorMessage, setErrorMessage] = useState('');

//   useEffect(() => {

//   if (Object.keys(data).length || error) {
//     setDisabled(false);
//   }

//   // API ERROR
//   if (error) {
//     setAlert({
//       type: "error",
//       recordName: "Entity",
//       action: "create",
//       message: "Fail to be created."
//     });
//   }

//   // SUCCESS → redirect
//   if (Object.keys(data).length) {
//     history.push("/company", {
//       tab: "entities",
//       alert: {
//         type: "success",
//         recordName: "Entity",
//         action: "create"
//       }
//     });
//   }

// }, [error, data, history]);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

   const handleSave = async () => {

  setDisabled(true);

  let form_errors = { entity_name: '', uen: '' };
  let is_error = false;

  if (!formData.entity_name) {
    form_errors.entity_name = "This field is required!";
    is_error = true;
  }

  if (!formData.uen) {
    form_errors.uen = "This field is required!";
    is_error = true;
  }

  setFormErrors(form_errors);

  // ✅ SHOW ERROR TOAST
  if (is_error) {
    setDisabled(false);

    setAlert({
      type: "error",
      recordName: "Entity",
      action: "create",
      message: "Fail to be created."
    });

    return;
  }
console.log("Saving entity...");
  // API CALL
  try {
    const res = await apiHelper('entities/create/', 'POST', formData);
    // ✅ after success
    console.log("API response:", res);
    if (res) {
      console.log("Redirecting to company with entities tab");
      console.log("Redirecting to company with entities tab");
      history.push({
        pathname: "/company",
        state: { activeTab: "entities", success: "Entity Saved Successfully" }
      });
    }
  } catch (error) {
    console.error('Failed to save entity:', error);
  }

};

   


    const breadcrumbs = [
        "Organisations",
        "Company",
        "Entities",
        activeTab
    ];

    return (
        <>
            <div className="company-body main-company-body-inner">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "Entities" ? "clickable" : ""}`}
                                onClick={() => {
                                    if (crumb === "Entities") {
                                        history.push("/company", { tab: "entities" });
                                    }
                                }}
                                style={{ cursor: crumb === "Entities" ? "pointer" : "default" }}
                            >
                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>

                {alert && (
                    <AlertNotification
                        type={alert.type}
                        recordName={alert.recordName}
                        action={alert.action}
                        message={alert.message}
                        onClose={() => setAlert(null)}
                    />
                )}

                <div className='edit-organisation-info'>
                    <div className='edit-organisation-left'>
                        <h1>Add Entity</h1>
                    </div>
                    <div className='discard-save-organisation-right d-flex align-items-center gap-2'>
                        <button className="dark-button" type='button' onClick={handleDiscard}>Discard</button>
                         <DiscardConfirmationModal
                            isOpen={discardModalOpen}
                            onCancel={handleCancelDiscard}
                            onConfirm={handleDiscardConfirm}
                            entityName="Entity"  // 🔁 Change dynamically (e.g., “Category”, “Stock”)
                        />
                        <button className="dark-border" type='button' onClick={handleSave} disabled={disabled}>Add Entity</button>
                    </div>
                </div>

                <div className="info-section">
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Entity Info</h4>
                        </div>

                        {loading && <p>Loading...</p>}
                        
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>

                                {successMessage && <div style={{ color: 'green' }} className="success-message">{successMessage}</div>} 

                                <ul style={{ color: 'red' }}>
                                  {validationError && validationError.map((error, index) => (
                                    <li key={index}>{error}</li>
                                  ))}
                                </ul>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="entityname" className="form-label ">
                                                Entity Name <span className='error-color'>*</span>
                                            </label>
                                            <input type="text" className={`form-control common-input-all ${errors.entity_name? 'err-color':''}`} name="entity_name" value={formData.entity_name} onChange={handleChange} id="entityname" placeholder="Entity Name" />
                                            {errors.entity_name && <p style={{ color: 'red' }}>{errors.entity_name}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="status" className="form-label">
                                                Status <span className='error-color'>*</span>
                                            </label>
                                            <div className='flexing-type-radio'>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" value="1" checked={formData.status === '1'} name="status" onChange={handleChange} id="flexRadioDefault1" />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                        Active
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" value="0" checked={formData.status === '0'} name="status" onChange={handleChange} id="flexRadioDefault2" />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                                        Inactive
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="shortName" className="form-label d-flex align-items-center gap-2">
                                                Short Name
                                                <Tooltip title="Short Name" body="A shorter, human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control common-input-all"
                                                id="shortName"
                                                name="entity_short_name"
                                                placeholder="Entity Short Name"
                                                onChange={handleChange}
                                                value={formData.entity_short_name}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="uen" className="form-label d-flex align-items-center gap-1">
                                                UEN <span className='error-color'>*</span>
                                                <Tooltip title="UEN" body="Human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <select name="uen" value={formData.uen} onChange={handleChange} className={`form-select new-form-select-cls  ${errors.entity_name? 'err-color':''}`} aria-label="Default select example">
                                                <option defaultValue>Select Parent Department</option>
                                                <option>Select Department One</option>
                                                <option>Select Department Two</option>
                                                <option>Select Department Three</option>
                                            </select>
                                            {errors.uen && <p style={{ color: 'red' }}>{errors.uen}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="parentEntity" className="form-label d-flex align-items-center gap-1">
                                                Parent Entity
                                                <Tooltip title="Parent Entity" body="Friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <select name="parent_id" value={formData.parent_id} onChange={handleChange} className="form-select new-form-select-cls" aria-label="Default select example">
                                                <option defaultValue>Select Parent Entity</option>
                
                                                { entities && entities.map((item, index) => (
                                                    <option key={index} value={item.entity_id}>{item.entity_name}</option>
                                                ))}
                                                
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="info-card">
                        <div className="info-header">
                            <h4 className="info-title">Additional Info</h4>
                        </div>
                        <div className="info-content">
                            <div className="info-inner common-textarea">
                                <label htmlFor="exampleFormControlTextarea1" className="form-label">Note</label>
                                <textarea name="note" value={formData.note} onChange={handleChange} 
                                className="form-control w-100 common-textarea-all" id="exampleFormControlTextarea1"
                                 rows="3"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}